<template>
  <v-dialog
      v-model="showTokenGenerator"
      persistent
      max-width="600px"
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">Create Token</span>
      </v-card-title>
      <v-card-text class="py-0">
        <v-list-item class="px-0">
          <v-list-item-avatar color="primary" class="white--text font-weight-bold">
            {{$helper.getImageName(currentLinkBot.bot_name || '') }}
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{currentLinkBot.bot_name}}</v-list-item-title>
            <v-list-item-subtitle>{{currentLinkBot.bot_code}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="py-2"/>
      </v-card-text>
      <v-card-text class="d-inline-flex">
        <v-text-field
            :disabled="!currentLinkBot.token"
            :value="currentLinkBot.token"
            outlined
            dense
            class="rounded-lg"
            flat
            solo
            type="password"
        ></v-text-field>
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                :disabled="!currentLinkBot.token"
                :color="copied ? 'secondary': 'primary'"
                icon
                dark
                v-bind="attrs"
                v-on="on"
                @click="copyToken"
            >
              <v-icon v-if="copied">mdi-check</v-icon>
              <v-icon v-else>mdi-content-copy</v-icon>
            </v-btn>
          </template>
          <span>Copy token</span>
        </v-tooltip>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn
            depressed
            class="text-none"
            @click="close"
        >
          Close
        </v-btn>
        <v-btn
            :loading="loading"
            color="primary"
            depressed
            class="text-none"
            @click="generateToken"
        >
          Create token
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {sync} from "vuex-pathify";
import {ApplicationService} from "@/services";
import AppService from "@/services/app.service";


export default {
  name: "TokenGenerator",
  data() {
    return {
      loading: false,
      copied: false,
    }
  },
  computed: {
    showTokenGenerator: sync('dialogs/showTokenGenerator'),
    currentLinkBot: sync('application/currentLinkBot')
  },
  methods: {
    generateToken() {
      this.loading = true
      ApplicationService.createIntegrationToken({
        link_bot_id: this.currentLinkBot.id
      })
          .then((res)=> {
            this.currentLinkBot.token = res.data
          })
          .finally(() => {
            this.loading = false
          })
    },
    close() {
      this.showTokenGenerator = false
    },
    copyToken() {
      if (this.copied) {
        return;
      }
      AppService.copyToClipboard(this.currentLinkBot.token)
      this.copied = true
      setTimeout(() => {
        this.copied = false
      },2000)

    }
  }
}
</script>

<style scoped>

</style>
